import { useCallback, useEffect, useState } from 'react';
import { ButtonElem, ButtonVariantEnum } from '../../components/Button';
import { Leaderboard } from '../../components/Leaderboard';
import useGameContext from '../../context/GameContext';
import { useLanguage } from '../../context/LanguageContext';
import useLeaderboardContext from '../../context/LeaderboardContext';
import usePlayerContext from '../../context/PlayerContext';
import { useSearchNavigate } from '../../hooks/useSearchNavigate';
import { Layout } from '../../layouts/Layout';
import { ROUTES } from '../../routes';
import { numberFormatter } from '../../utils/formatter';
import { Container } from './styles';
import { FloatingLogo } from '../../components/FloatingLogo';

export function Result() {
  const { leaderboard, fetchCurrentSessionLeaderboard } = useLeaderboardContext();
  const { gameSession, createGameSession, questionCount, surveyQuestionCount } = useGameContext();
  const { player } = usePlayerContext();
  const navigate = useSearchNavigate();
  const { language, languageSelector } = useLanguage();
  const [pressedHome, setPressedHome] = useState(false);
  const [pressedInHome, setPressedInHome] = useState(false);
  const [pressedPlayAgain, setPressedPlayAgain] = useState(false);
  const [pressedInPlayAgain, setPressedInPlayAgain] = useState(false);

  useEffect(() => {
    fetchCurrentSessionLeaderboard(gameSession?.documentId as string);
  }, []);

  const currentPosition = leaderboard?.find((el) => el.documentId === gameSession?.documentId);

  const handleCreateGameSession = useCallback(async () => {
    await createGameSession();
    navigate(ROUTES.Countdown);
  }, [createGameSession, navigate]);

  const earnedQuestionCount =
    gameSession?.questionsAnswered.reduce((acc, curr) => {
      const isSurvey = curr.question?.category === 'Survey';
      const earnsCredit = isSurvey ? curr.answerId != null : curr.correctAnswerId === curr.answerId;
      return earnsCredit ? acc + 1 : acc;
    }, 0) ?? 0;

  const totalQuestionCount = questionCount + surveyQuestionCount;

  return (
    <Layout>
      <Container>
        <FloatingLogo />
        <main>
          <h1>{language.citis_new_way}</h1>
          <h2>{language.congratulations}</h2>
          <h3>{language.high_score}</h3>
          <p className="questions-result">
            {earnedQuestionCount}/{totalQuestionCount}
          </p>

          <p className="score-result">
            {language.your_score}{' '}
            {numberFormatter(languageSelector).format(gameSession?.points || 0)} {language.pts}.
          </p>

          <div>
            <ButtonElem
              className={pressedPlayAgain ? (pressedInPlayAgain ? 'pressed' : 'notpressed') : ''}
              onClick={() => {
                setPressedPlayAgain(true);
                setPressedInPlayAgain(true);
                setTimeout(() => {
                  setPressedInPlayAgain(false);
                }, 500);
                setTimeout(() => {
                  handleCreateGameSession();
                }, 1000);
              }}
              variant={ButtonVariantEnum.SECONDARY}>
              {language.play_again}
            </ButtonElem>
            <ButtonElem
              className={pressedHome ? (pressedInHome ? 'pressed' : 'notpressed') : ''}
              onClick={() => {
                setPressedHome(true);
                setPressedInHome(true);
                setTimeout(() => {
                  setPressedInHome(false);
                }, 500);
                setTimeout(() => {
                  navigate(ROUTES.Home);
                }, 1000);
              }}
              variant={ButtonVariantEnum.SECONDARY}>
              {language.home}
            </ButtonElem>
          </div>
        </main>
        <aside>
          <h2>
            {language.thanks_for_playing}
            <br />
            {`${player?.first_name} ${player?.last_name}!`}
          </h2>

          <h3>{language.check_your_leaderboard}</h3>

          <Leaderboard
            small
            highlightPosition={currentPosition ? currentPosition.position : undefined}
            results={leaderboard}
          />
        </aside>
      </Container>
    </Layout>
  );
}
